"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import Auth from "../util/auth";
class ModuleDropdown extends React.Component {
  render() {
    if (Auth.isAuthenticated() && this.showDropdown()) {
      return this.dropdownMenu();
    } else {
      return /* @__PURE__ */ jsx("div", { "data-component": "ModuleDropdown" });
    }
  }
  dropdownTitle() {
    if (this.props.location.pathname === "/to_be_scraped_loads") {
      return /* @__PURE__ */ jsx("a", { href: "/app/to_be_scraped_loads", children: " Documents " });
    } else if (this.props.location.basename.match(/customer_invoicing/)) {
      return /* @__PURE__ */ jsx("a", { href: "/customer_invoicing", children: " Receivables " });
    } else if (this.props.location.pathname.startsWith("/noa_management")) {
      return /* @__PURE__ */ jsx("a", { href: "/app/noa_management", children: " NOA Management " });
    } else if (this.props.location.pathname !== "/login") {
      return /* @__PURE__ */ jsx("a", { href: "/app/dashboard", children: " Payables " });
    }
  }
  dropdownMenu() {
    return /* @__PURE__ */ jsx("ul", { className: "left", id: "module-dropdown", "data-component": "ModuleDropdown", children: /* @__PURE__ */ jsxs("li", { className: "has-dropdown not-click", children: [
      this.dropdownTitle(),
      /* @__PURE__ */ jsxs("ul", { className: "dropdown", children: [
        this.possibleDocumentsLink(),
        this.possiblePayablesLink(),
        this.possibleReceivablesLink(),
        this.possibleNoaManagementLink(),
        this.possibleCustomerRepresentativeLink(),
        this.possibleInsightsDashboardLink()
      ] })
    ] }) });
  }
  possibleDocumentsLink() {
    if (this.showDocuments()) {
      return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx("a", { href: "/app/to_be_scraped_loads", children: "Documents" }) });
    }
  }
  possiblePayablesLink() {
    if (this.showPayables()) {
      return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx("a", { href: "/app/dashboard", children: "Payables" }) });
    }
  }
  possibleNoaManagementLink() {
    if (this.showNoaManagement()) {
      return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx("a", { href: "/app/noa_management", children: "NOA Management" }) });
    }
  }
  possibleReceivablesLink() {
    if (this.showReceivables()) {
      return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx("a", { href: "/customer_invoicing", children: "Receivables" }) });
    }
  }
  possibleCustomerRepresentativeLink() {
    if (this.showCustomerRepresentative()) {
      return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx("a", { href: "/customer_representative", children: "Customer Representative" }) });
    }
  }
  possibleInsightsDashboardLink() {
    if (this.showInsightsDashboard()) {
      return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx("a", { href: "/insights_dashboard", children: "Insights" }) });
    }
  }
  showDropdown() {
    return _.filter(
      [
        this.showDocuments(),
        this.showPayables(),
        this.showNoaManagement(),
        this.showReceivables(),
        this.showCustomerRepresentative(),
        this.showInsightsDashboard()
      ],
      function(i) {
        return i;
      }
    ).length > 1;
  }
  showDocuments() {
    return this.account().scraper_account;
  }
  showPayables() {
    return this.account().payables_account || this.account().factor_account;
  }
  showNoaManagement() {
    return this.account().settings.noa_management_enabled;
  }
  showReceivables() {
    return this.account().receivables_account && this.currentUser().receivables;
  }
  showCustomerRepresentative() {
    return this.account().customer_representative_view_enabled && this.currentUser().customer_representative;
  }
  showInsightsDashboard() {
    const insightsDashboardEnabled = this.account().payables_account || this.account().settings.insights_dashboard_enabled;
    return insightsDashboardEnabled && this.currentUser().insights_dashboard_access;
  }
  account() {
    return Auth._currentUser.account;
  }
  currentUser() {
    return Auth._currentUser;
  }
}
export default ModuleDropdown;
